/*
 * 企業側 ファイル共有 一覧取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CLIENT_SHARE_DOCUMENT_MESSAGE_FILE = 'API_GET_ONE_CLIENT_SHARE_DOCUMENT_MESSAGE_FILE';
/**
 * ファイル共有 個別送付の共有済みメッセージのファイル取得
 */
export const apiGetOneClientRfpShareDocumentMessageFile = ({ path: { id, share_document_message_file_id: shareDocumentMessageFileId } }, meta) => apiGetList(API_GET_ONE_CLIENT_SHARE_DOCUMENT_MESSAGE_FILE, `/client/rfp/${id}/share_document_message/download_file/${shareDocumentMessageFileId}`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
